import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS, GRUPO_EXIBIR_ITENS_MENU_USUARIO_SG, ITEM_MENU_ACESSO_CONSULTA, MODO_PERSPECTIVA_ITENS_MENU_USUARIO, PERMISSAO_ALTERAR_SENHA_USUARIO, PERMISSAO_ITENS_MENU_USUARIO } from '../../../app.constants';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';
import { InstitucionalItensDTO } from '../../shared/dominios/DTO/institucional-itens.DTO';
import { ItemMenu } from '../../shared/dominios/item-menu';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { InstitucionalModel } from '../../shared/models/institucional.model';
import { PessoaDadosModel } from '../../shared/models/pessoa-dados.model';
import { DocumentosService } from '../../shared/services/documentos.service';
import { PermissaoModulosService } from '../../shared/services/permissoes-modulos.service ';
import { PessoaService } from '../../shared/services/pessoa.service';
import { ValidarPermissaoFuncionalidadeService } from '../../shared/services/validar-permissao-funcionalidades.service';
import { FuncoeslimparFormatacao } from '../../shared/util/funcoes-limpar-formatacao';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { ValidacaoUtil } from '../../shared/util/validacao.util';

@Component({
  selector: 'app-operacoes-consulta-participante',
  templateUrl: './operacoes-consulta-participante.component.html',
  styleUrls: ['./operacoes-consulta-participante.component.css']
})
export class OperacoesConsultaParticipanteComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  param = '/cardMenus/cardMenuAdministrativo';

  institucionalModel = new InstitucionalModel();
  pessoa = new PessoaDadosModel();

  cpf: string;

  liberarCpf = false;

  BuscaCPF: any[] = [];
  ComboBox: any[] = [];
  LinksPDFs: any[] = [];

  filhoDosFilhos: any[];
  itensMenu: ItemMenu[] = [];

  disabled = false;
  disabilitarBotacao: Boolean;
  isAposentado: Boolean = true;

  // itemMenu$: Observable<ItemMenu[]>;

  constructor(
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private validarPermissaoFuncionalidadeService: ValidarPermissaoFuncionalidadeService,
    private permissaoModulosService: PermissaoModulosService,
    private authInterceptor: AuthInterceptor,
    private router: Router,
    private documentosService: DocumentosService,
    private store: Store<ItemMenu>
  ) {
  }

  ngOnInit() {
    this.findItemMenu();


    this.getDadosSesseionStorage();

    if (!this.disabled) { StorafeUtil.limparSessionStorage(CODIGO_CENTRUS) };


    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
    const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
    const permitirAcessoItensMenuUsuario = StorafeUtil.recuperarSessionStorage(PERMISSAO_ITENS_MENU_USUARIO);
    if (modoConsultadoUusario) { (permitirAcessoItensMenuUsuario) ? (this.disabilitarBotacao = true) : (this.disabilitarBotacao = false, (this.router.navigateByUrl('/home', { skipLocationChange: true }))) };
  }


  getDadosSesseionStorage(): void {
    try {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
      if (recuperandoObjeto) { this.disabled = Boolean(recuperandoObjeto) };

    } catch (error) {
      console.error(error);
    }
  }


  async findItemMenu() {

    try {

      this.validarPermissaoFuncionalidadeService.getItensMenuLateral()
        .then(itensMenu => (this.itensMenu = itensMenu) && (this._buscarPai(itensMenu)))
    } catch (error) {
      console.error(error);
    }

  }

  private _buscarPai(itensMenu): void {

    let idItemPai = null;
    this.filhoDosFilhos = [];

    try {
      const itemMenuNome = JSON.parse(StorafeUtil.recuperarSessionStorage(ITEM_MENU_ACESSO_CONSULTA));
      idItemPai = itensMenu.find(item => item.sgItemMenu.toLowerCase() === itemMenuNome.toLowerCase());

      this.filhoDosFilhos.push(new InstitucionalItensDTO('', 'Selecione um tipo para consultar', null));

      // PERMISSAO_ALTERAR_SENHA_USUARIO

      // console.log(itensMenu);


      const permissaoAlterarSenhaUsuario = itensMenu.find(index => index.sgItemMenu === 'alt_senha_sar');

      if (permissaoAlterarSenhaUsuario) { StorafeUtil.gravaSessionStorage(PERMISSAO_ALTERAR_SENHA_USUARIO, permissaoAlterarSenhaUsuario.irAtivo) }

      itensMenu.filter((item, index, lista) => (item.itemMenuPai && idItemPai) && (item.itemMenuPai.idItemMenu === idItemPai.idItemMenu)
        && (item.sgItemMenu !== 'alt_senha_sar')
        && (this.filhoDosFilhos.push(new InstitucionalItensDTO(item.sgItemMenu, item.dsItemMenu, item.idItemMenu, item.dsUrl))))

      // this._verificacaoCamposCPF(tipoConsulta.id);

    } catch (error) {
      console.error(error);
    }

  }

  // FuncoeslimparFormatacao.limparDados
  private _validarCpf(cdLogin): Boolean {
    if (!ValidacaoUtil.validarCpf(cdLogin)) {
      this.toastrService.error(MessageUtil.CPF_INVALIDO, '', { timeOut: 5000 })
      return false
    }
    return true
  }


  async getPessoaDadosCPF(cpf: string): Promise<PessoaDadosModel> {
    return await this.pessoaService.getPessoaDadosCPF(cpf);
  }

  private _gravaSessionStorage(titulo: string, dado): void {
    StorafeUtil.gravaSessionStorage(titulo, dado);
  }


  async pesquisar(institucionalModel: InstitucionalItensDTO, cpf: string): Promise<void> {


    if (!institucionalModel.id || !cpf) {
      this.toastrService.warning(MessageUtil.CAMPOS_OBRIGATORIOS);
      return;
    }

    const cpfLimpo = FuncoeslimparFormatacao.limparDados(cpf);

    if (!this._validarCpf(cpfLimpo)) { return; }


    const pessoa = await this.getPessoaDadosCPF(cpfLimpo);

    if (!pessoa) {
      this.toastrService.warning('A pessoa responsavel por esse CPF não está cadastrada em nossa sistema.', 'Atenção', { timeOut: 8000 })
      return;
    }


    // if (institucionalModel.id === 'icap' && this.isAposentado) {
    //   this.toastrService.info('Essa pessoa ainda não é aposentada.', 'Atenção', { timeOut: 10000 })
    //   return;
    // }

    if (institucionalModel.id === 'cemu') {

      const temEsseGrupo = await this.permissaoModulosService.getBySgGrupoAcesso(this.authInterceptor.getJwtCdCentrus(), GRUPO_EXIBIR_ITENS_MENU_USUARIO_SG);

      (temEsseGrupo) ? this._gravaSessionStorage(PERMISSAO_ITENS_MENU_USUARIO, true) : StorafeUtil.limparSessionStorage(PERMISSAO_ITENS_MENU_USUARIO);

      this._gravaSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO, true);
      this._gravaSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO, true);
      this._gravaSessionStorage(CODIGO_CENTRUS, pessoa.cdCentrus);
      this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() => this.router.navigate([decodeURI('/home')]));
      ValidarPermissaoFuncionalidadeService.atualiazarItemMenu.emit(true);
      return;
    }


    if (institucionalModel.id === 'o_pbb_formdp_ar') {
      this.documentosService.downloandDocument('pdf', institucionalModel.caminho);
      return;
    }

    this._gravaSessionStorage(CODIGO_CENTRUS, pessoa.cdCentrus);
    this.router.navigateByUrl(institucionalModel.caminho, { skipLocationChange: true })


  }



}
// @throttle()



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/operacoes-consulta-participante/operacoes-consulta-participante.component.ts